import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import { useNavigate } from "react-router-dom";
import url from "../../config.js";
import intelogicon from "../../assets/icons/intelog_new_png.png";
import "../login/login.scss";

const domain = url.domain;

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { setError("Please enter your email address."); return; }
    setError("");
    setLoading(true);
    try {
      await fetch(`${domain}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      setSubmitted(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <CssBaseline />
      <div className="login-split-container">

        {/* Left — branding */}
        <div className="login-left-side">
          <div className="branding-content">
            <div className="logo-wrapper">
              <img src={intelogicon} alt="INTELOG" className="brand-logo" />
            </div>
            <div className="quote-section">
              <h1 className="brand-headline">Reset your password</h1>
              <p className="brand-description">
                Enter your registered email and we'll send you a secure link to choose a new password.
              </p>
            </div>
          </div>
        </div>

        {/* Right — form */}
        <div className="login-right-side">
          <div className="form-wrapper">
            {submitted ? (
              <div className="success-container">
                <div className="success-icon-container">
                  <div className="success-icon-circle">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </div>
                </div>
                <div className="success-message-box">
                  <h2 className="success-message-title">Check your email</h2>
                  <p className="success-message-text">
                    If an account exists for <strong>{email}</strong>, a reset link has been sent. Check your inbox and spam folder.
                  </p>
                </div>
                <button type="button" className="form-button" onClick={() => navigate("/")}>
                  Back to Login
                </button>
              </div>
            ) : (
              <div className="form-container">
                <div className="form-header">
                  <h2 className="form-title">Forgot Password</h2>
                  <p className="form-subtitle">We'll email you a link to reset your password.</p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-label">Email Address</label>
                    <TextField
                      className="form-input"
                      variant="outlined"
                      fullWidth
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoFocus
                    />
                  </div>

                  {error && <div className="error-message">{error}</div>}

                  <button
                    type="submit"
                    className="form-button"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Reset Link"}
                  </button>
                </form>

                <div className="switch-link">
                  Remember your password?{" "}
                  <a href="#" onClick={(e) => { e.preventDefault(); navigate("/"); }}>
                    Back to Login
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default ForgotPassword;
